import {lazy} from 'react';

export const PriipsLazy = lazy(() => import(/* webpackChunkName: "samDocumentSearch-priips" */ '.'));
